/* ==========================================================================
   MASHWI — Motion
   Révélations au défilement (.mw-reveal) + compteurs animés [data-mw-counter]
   Vanilla, aucune dépendance. Respecte prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SUPPORTS_IO = 'IntersectionObserver' in window;
  var COUNTER_DURATION = 900;

  /* ------------------------------------------------------------------
     Révélations — ajoute .is-visible à l'entrée dans le viewport.
     Le décalage (70 ms par élément) est géré en CSS via --mw-reveal-index ;
     si l'index n'est pas posé dans le markup, on le déduit du lot.
     ------------------------------------------------------------------ */
  function revealNow(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('is-visible');
    }
  }

  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.mw-reveal:not(.is-visible)');
    if (!nodes.length) return;

    if (REDUCED || !SUPPORTS_IO) {
      revealNow(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var batchIndex = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var hasIndex = getComputedStyle(el)
            .getPropertyValue('--mw-reveal-index')
            .trim();
          if (!hasIndex) {
            el.style.setProperty('--mw-reveal-index', String(batchIndex));
          }
          batchIndex += 1;
          el.classList.add('is-visible');
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Compteurs — <span data-mw-counter data-target="90" data-suffix=" %">
     Anime de 0 vers data-target en 900 ms, une seule fois.
     Décimales déduites de data-target, virgule décimale (fr-CA).
     ------------------------------------------------------------------ */
  var DECIMAL_SEP =
    (document.documentElement.lang || 'fr').indexOf('fr') === 0 ? ',' : '.';

  function formatValue(value, decimals) {
    return value.toFixed(decimals).replace('.', DECIMAL_SEP);
  }

  function finalText(el) {
    var target = parseFloat(el.dataset.target);
    var decimals = (String(el.dataset.target).split('.')[1] || '').length;
    return (el.dataset.prefix || '') + formatValue(target, decimals) + (el.dataset.suffix || '');
  }

  function animateCounter(el) {
    if (el.dataset.mwCounterDone) return;
    el.dataset.mwCounterDone = 'true';

    var target = parseFloat(el.dataset.target);
    if (isNaN(target)) return;

    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var decimals = (String(el.dataset.target).split('.')[1] || '').length;
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / COUNTER_DURATION, 1);
      var eased = 1 - Math.pow(1 - progress, 3); /* easeOutCubic */
      el.textContent = prefix + formatValue(target * eased, decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    }

    requestAnimationFrame(frame);
  }

  function initCounters(root) {
    var nodes = (root || document).querySelectorAll(
      '[data-mw-counter]:not([data-mw-counter-done])'
    );
    if (!nodes.length) return;

    if (REDUCED || !SUPPORTS_IO) {
      nodes.forEach(function (el) {
        if (isNaN(parseFloat(el.dataset.target))) return;
        el.textContent = finalText(el);
        el.dataset.mwCounterDone = 'true';
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach(function (el) {
      if (isNaN(parseFloat(el.dataset.target))) return;
      /* La valeur finale reste lisible par les technologies d'assistance */
      el.setAttribute('aria-label', finalText(el));
      observer.observe(el);
    });
  }

  function init(root) {
    initReveal(root);
    initCounters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Garde-fou : quoi qu'il arrive (IO qui ne se déclenche pas, capture headless,
     erreur tierce), aucun contenu ne reste invisible plus de 3 s dans le viewport. */
  window.setTimeout(function () {
    var pending = document.querySelectorAll('.mw-reveal:not(.is-visible)');
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < pending.length; i++) {
      var rect = pending[i].getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        pending[i].classList.add('is-visible');
      }
    }
  }, 3000);

  /* Éditeur de thème Shopify : ré-initialise la section rechargée */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
